<template>
  <div>
    <app-header />
    <mpn-page-title :title="pageTitle" />

    <!-- S : main -->
    <main class="a-service-main">
      <!-- S : 컨텐츠 영역 -->
      <div
        id="main_content"
        class="a-service-container"
      >
        <!-- !!!! contents here -->
        <mpn-input-number-only
          v-model="number1"
          type="text"
          class="form_input"
          maxlength="4"
          @change="onChange"
        />
      <!-- contents here !!!! -->
      </div>
      <!-- E : 컨텐츠 영역 -->
    </main>
    <!-- E : main -->

    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'Test',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      pageTitle: 'Test Page',
      number1: '123',

    };
  },
  methods: {
    onChange() {
      console.log('onChange-test');
    },
  },
};
</script>
